/**
 * RealtimeConnection: owns the app's one Socket.IO connection. Renders nothing.
 *
 * Mounted once, under the authenticated route tree (see App.tsx), and never
 * for the public pages (shared chat, meetup, RSVP). Every realtime consumer
 * (`useWebSocketEvents` in AppLayout, the files and knowledge hooks, the
 * avatar sync) only SUBSCRIBES; without this owner the socket was never
 * opened and every one of those subscriptions was a silent no op.
 *
 * It is its own component so the connection state changes it re-renders on
 * do not re-render the route tree. Sign out unmounts it (AuthGate stops
 * rendering the authenticated tree), which lets go of the connection.
 */

import { useWebSocket } from '@/hooks/useWebSocket';
import { useIsAuthenticated } from '@/stores/authStore';

export function RealtimeConnection(): null {
  const isAuthenticated = useIsAuthenticated();
  // Never connect while signed out: autoConnect follows the auth state, and a
  // false value releases an open connection.
  useWebSocket({ autoConnect: isAuthenticated });
  return null;
}
